<div class="auth-modal-container signup" *ngIf="showForm">
  <form novalidate [formGroup]="signUpForm" class="form-container">

    <div class="logo-img"></div>

    <div class="form-header">
      Create an account
    </div>

    <div class="form-row two-items">
      <app-input [type]="'text'"
                 [label]="'First name'"
                 formControlName="firstName"
                 [autofocus]="true"
                 #firstNameInput
                 (keyupEnter)="focusInput('lastNameInput')"
      ></app-input>
      <app-input [type]="'text'"
                 [label]="'Last name'"
                 formControlName="lastName"
                 #lastNameInput
                 (keyupEnter)="focusInput('emailInput')"
      ></app-input>
    </div>

    <app-input [type]="'email'"
               [label]="'Email'"
               formControlName="email"
               #emailInput
               (keyupEnter)="focusInput('passwordInput')"
    ></app-input>
    <app-input [type]="'password'"
               [label]="'Password'"
               formControlName="password"
               #passwordInput
               (keydownTab)="focusCreateMyAccount()"
    ></app-input>

    <div *ngIf="!inviteData" class="pricing-container">
      <div *ngIf="currentPricingOption?.id" class="current-pricing">
        <div class="pricing-header">{{currentPricingOption.header}}:</div>
        <div class="name">{{currentPricingOption.name}}</div>
        <div class="description">{{currentPricingOption.description}}</div>
      </div>

      <!-- <app-dropdown class="pricing-options"
                    [label]="'Pricing Options'"
                    [placeholder]="''"
                    formControlName="pricingId"
                    [isOptionObject]="true"
                    [hasCustomTemplate]="true"
                    [options]="pricingMonthOptions"
                    [radioButtons]="true"
                    [fullWidth]="true"
                    [showDescription]="true"
                    (dropdownOpened)="focusDropdown()"
                    #pricingOptionsDropdown
      >
        <app-tabs (click)="$event.stopPropagation()"
                  (tabSelected)="tabChanged($event)"
                  [tabsMarginLeft]="'16px'"
                  [hasUnderline]="true"
        >
          <app-tab [tabValue]="SignUpPriceEnum.Month"
                   [hasCount]="false"
                   [tabTitle]="'Monthly'"
                   [active]="currentTab === SignUpPriceEnum.Month"
          >
            <app-options-list formControlName="pricingIdMonth"
                              [optionsList]="pricingMonthOptions"
                              [hasCustomTemplate]="true"
                              [isHorizontal]="true"
                              (optionSelected)="choosePricingOption($event)"
                              #pricingMonthOptionsList
            >
              <ng-template let-option let-i="idx">
                <div (click)="selectPricingOption(i)"
                     (keydown.space)="selectPricingOption(i)"
                     [class.checked]="option.checked"
                     class="pricing-template"
                >
                  <div class="pricing-header">
                    {{option.header}}
                  </div>
                  <div class="pricing-body">
                    <div class="price">
                      ${{option.price}}<span> /mon.</span>
                    </div>
                    <div class="type">
                      Billed monthly.
                    </div>
                  </div>
                </div>
              </ng-template>
            </app-options-list>
          </app-tab>
          <app-tab [tabValue]="SignUpPriceEnum.Year"
                   [hasCount]="false"
                   [tabTitleHTML]="yearPriceHeader"
                   [active]="currentTab === SignUpPriceEnum.Year"
          >
            <app-options-list formControlName="pricingIdYear"
                              [optionsList]="pricingYearOptions"
                              [hasCustomTemplate]="true"
                              [isHorizontal]="true"
                              (optionSelected)="choosePricingOption($event)"
                              #pricingYearOptionsList
            >
              <ng-template let-option let-i="idx">
                <div (click)="selectPricingOption(i)"
                     (keydown.space)="selectPricingOption(i)"
                     [class.checked]="option.checked"
                     class="pricing-template"
                >
                  <div class="pricing-header">
                    {{option.header}}
                  </div>
                  <div class="pricing-body">
                    <div class="price">
                      ${{option.price}}<span> /mon.</span>
                    </div>
                    <div class="type">
                      {{option.description}}
                      <app-badge [color]="BadgeColorsEnum.LightBlue" [maxWidth]="'216px'">
                        Get 2 months FREE
                      </app-badge>
                    </div>
                  </div>
                </div>
              </ng-template>
            </app-options-list>
          </app-tab>
        </app-tabs>
      </app-dropdown> -->
    </div>

    <app-button customClasses="w-full"
                class="submit-btn"
                [disabled]="(loading$ | async) || signUpForm.invalid"
                [text]="'Create my account'"
                (clicked)="createAccount()"
                [loading]="loading$ | async"
                #createMyAccountButton
                (keydownTab)="focusInput('firstNameInput')"
    ></app-button>

    <div class="already-signed">
      Already have an account?
      <a class="sign-in-ref" routerLink="/auth/login">Sign in</a>
    </div>
  </form>

  <div class="label-container">
    <div *ngIf="inviteData" class="label-header login">
      Love <br>
      managing <br>
      your <br>
      controlled <br>
      substance <br>
      inventory.
    </div>

    <ng-container *ngIf="!inviteData">
      <div class="label-header">
        What you'll need <br/>
        to register
      </div>

      <div class="label-item">
        <span>Pharmacy NPI Number</span>
      </div>
      <div class="label-item">
        <span>Pharmacy License Number</span>
      </div>
      <div class="label-item">
        <span>Pharmacy License Expiration Date</span>
      </div>
      <div class="label-item">
        <span>Pharmacy DEA Number</span>
      </div>
      <div class="label-item">
        <span>Pharmacy DEA Expiration Date</span>
      </div>
      <div class="label-item">
        <span>A unique 4-digit PIN</span>
      </div>
    </ng-container>
  </div>

</div>

<div class="auth-modal-container right-label" *ngIf="showInvitationErrors">
  <form
    novalidate
    class="form-container"
  >
    <div class="logo-img"></div>
    <div class="form-header" *ngIf="userExistsError">
      Link has already been used
    </div>
    <div class="form-header" *ngIf="invitationExpired">
      Link has expired
    </div>
    <div class="form-description" *ngIf="userExistsError">
      This link has already been used to create an account. Please <a routerLink="/auth/login"
                                                                      class="label-later animation-focus-default sign-up-link">log
      in</a> if you have already created your account.
    </div>
    <div class="form-description" *ngIf="invitationExpired">
      You may not create an account with an expired email link. Please contact your pharmacy administrator to request a
      new link to register.
    </div>
  </form>
</div>
